import React, {useCallback, type ComponentProps} from 'react';
import {useNode} from '@craftjs/core';
import {useEditorStyle} from 'hooks';
import {classNames} from 'utils';

interface IEditorContentImageProps extends ComponentProps<'img'> {
  mobileStyle?: React.CSSProperties;
}

const EditorContentImage = ({mobileStyle, ...props}: IEditorContentImageProps) => {
  const {
    connectors: {connect, drag},
    selected,
    hovered,
  } = useNode(node => ({
    selected: node.events.selected,
    hovered: node.events.hovered,
  }));

  const ref = useCallback((node: HTMLImageElement) => {
    if (node) {
      connect(drag(node));
    }
  }, []);

  const {style} = useEditorStyle();

  return (
    <div
      {...props}
      ref={ref}
      className="relative"
      style={{...style, width: props.src ? style?.width : '100px', height: props.src ? style?.height : '100px'}}>
      <div
        className={classNames(
          'absolute inset-0 pointer-events-none',
          hovered ? 'shadow-[inset_0_0_0_2px_#34bb78]' : selected ? 'shadow-[inset_0_0_0_2px_#acbdd4]' : '',
        )}></div>
      <img {...props} style={{...props.style, width: '100%', height: '100%', margin: 0, objectFit: 'cover'}} />
    </div>
  );
};

EditorContentImage.craft = {
  displayName: 'Image',
  custom: {
    icon: 'PhotoIcon',
  },
  props: {
    style: {
      width: '100%',
      height: '100%',
      maxWidth: '1080px',
      maxHeight: '1080px',
      backgroundColor: 'gray',
      margin: '0 0 0 0',
    },
    mobileStyle: {},
  },
};

export default EditorContentImage;
